/**
 * The words for a lockout (#1566 a, vingapi#2471, owner Q-678).
 *
 * The server answers a lockout with 423 and
 * `{detail: {code: 'sign_in_locked' | 'verify_locked', message, retry_after}}`.
 * The message is shown as sent when the body is that coded envelope; any other
 * 423 from the same endpoint gets the fixed line for that endpoint. No
 * countdown and no number computed from `retry_after`: the approved words are
 * fixed.
 */
import { identifyRefusal } from '@/api/knownRefusals';
import { alertMessages } from '@/constants/alertMessages';
import { extractApiMessage } from './apiError';

export function signInLockoutWords(error: unknown): string {
  return identifyRefusal(error)?.kind === 'sign_in_locked'
    ? extractApiMessage(error, alertMessages.auth.signInLocked)
    : alertMessages.auth.signInLocked;
}

export function verifyLockoutWords(error: unknown): string {
  return identifyRefusal(error)?.kind === 'verify_locked'
    ? extractApiMessage(error, alertMessages.auth.verifyLocked)
    : alertMessages.auth.verifyLocked;
}
